import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../shared/auth/auth.service';
import { Router } from '@angular/router';
import { logging } from 'protractor';
import { Logging } from '../../logging';
import { ComponentID, ActionType, PermissionHelper } from '../../shared/helpers/permissionshelper';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  constructor(private auth: AuthService,
     private router: Router,public componentid : ComponentID ,
     public actiontype: ActionType,public permhelper:PermissionHelper) { }

  ngOnInit() {

  }

  logout(){
    this.auth.logout();
  }

  user(){
    return this.auth.user();
  }

}



// WEBPACK FOOTER //
// ./src/app/client/header/header.component.ts